import { GlobalEnumsAceXfoundportalobjekt, PortalzugriffDisplayModel, UserDisplayModel } from '@/api/model-index';
import { PortalzugriffService, UserService } from '@/api/service-index';
import { Injectable } from '@angular/core';
import { DialogService } from '@progress/kendo-angular-dialog';
import { BehaviorSubject, forkJoin } from "rxjs";
import { FreigebenDialogComponent } from '../components/dialogs/freigeben-dialog/freigeben-dialog.component';
import { I18nService } from './i18nService';
import { LoadingAnimationService } from './loading-animation.service';
import { Constants } from '@/constants';

@Injectable({
  providedIn: 'root'
})
export class AnfrageLiveSharingService {

  public livePortalzugriffe: string[] = [];
  public livePortalzugriffeBehavior: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  public isFreigebenDialogOpen = false;

  constructor(public dialogService: DialogService, protected languageService: I18nService, protected portalzugriffService: PortalzugriffService, protected userService: UserService, protected loadingAnimationService: LoadingAnimationService) { }

  openFreigebenDialog(anfrageId: string, scope: GlobalEnumsAceXfoundportalobjekt, anfrageTitel: string | null, showLiveUsers: boolean) {
    if (this.isFreigebenDialogOpen)
      return

    this.isFreigebenDialogOpen = true;

    let promise = this.getPortalzugriffePromise(anfrageId, scope);

    this.loadingAnimationService.showSpinnerUsingPromise(promise);

    promise.then(response => {
      let freigebenDialog = this.dialogService.open({
        content: FreigebenDialogComponent,
        maxWidth: Constants.DIALOG.MAX_WIDTH,
        maxHeight: Constants.DIALOG.MAX_HEIGHT,
        minWidth: "60%",
        title: this.languageService.instant("freigebendialog.title"),
      });

      let dialogComponent: FreigebenDialogComponent = freigebenDialog.content.instance;

      dialogComponent.anfrageId = anfrageId,
        dialogComponent.scope = scope,
        dialogComponent.showLiveUsers = showLiveUsers;
      dialogComponent.portalzugriffe = response.zugriffe;
      dialogComponent.users = response.users;
      dialogComponent.anfrageTitel = anfrageTitel;

      freigebenDialog.result.subscribe((result) => {
        this.isFreigebenDialogOpen = false;
      });

      freigebenDialog.dialog.onDestroy((error: any) => {
        
      });

      //Bugfix: Kendo Dialog öffnet sich erst nach einem click
      (document.getElementById("blazor-anfrage-sharing") as HTMLElement)?.click();
    });

  }

  public getPortalzugriffePromise(anfrageId: string, scope: GlobalEnumsAceXfoundportalobjekt): Promise<{ zugriffe: PortalzugriffDisplayModel[]; users: UserDisplayModel[]; }> {
    let zugriffObs = this.portalzugriffService.apiPortalzugriffAnfrageIdGet({ anfrageId: anfrageId, "x-anfragescope": scope });
    let usersObs = this.userService.apiUserInstitutionGet();

    return forkJoin(
      {
        zugriffe: zugriffObs,
        users: usersObs
      }
    ).toPromise();
  }
}
